export default function toUpper (x) {
  return x.toUpperCase()
}
